import PropTypes from 'prop-types';

const UserType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  picture_url: PropTypes.string,
  primary_phone: PropTypes.string,
  primary_phone_type: PropTypes.string,
  active: PropTypes.bool,
  pending: PropTypes.bool,
});

export default UserType;

export const RoleType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});



// WEBPACK FOOTER //
// ./client/app/shared/types/user.js